export interface IInterfaceTypeSourceComputationFn {
  (sourceProp: any, requirement: IInterfaceDTDKey, source?: any, sync?: any): any;
}

export interface IInterfaceTypeIsOfTypeFn {
  (sourceProp: any, requirement: IInterfaceDTDKey): boolean;
}

export interface IInterfaceDTD {
  [property: string]: string | IInterfaceDTDKey;
}

// TODO write one of these for every type
export interface IInterfaceDTDKeyBase {
  type: string;
  typeDef?: string | Object;
  defaultValue?: any | IInterfaceTypeSourceComputationFn;
  synonyms?: string[];
  writeToKey?: string;
  preprocessor?: 'key-value-pair' | 'reverse-side-load-lookup';
  postprocessor?: 'side-load-lookup';
  optional?: boolean;
  required?: boolean;
}

export interface IInterfaceDTDKey extends IInterfaceDTDKeyBase {
  rules?: Object;
  hint?: Object;
}

export interface IInterfaceType {
  defaultValue: any | IInterfaceTypeSourceComputationFn;
  convertToSync: IInterfaceTypeSourceComputationFn;
  afterConvertToSync: IInterfaceTypeSourceComputationFn;
  convertToSource: IInterfaceTypeSourceComputationFn;
  isOfType: IInterfaceTypeIsOfTypeFn;
}

export interface IInterfaceConfiguation {
  logFailureFn?: () => void;
  integritySafeguards?: boolean;
  defaultToRequired?: boolean;
  failFast?: boolean;
}

export interface IInterfacePreprocessor {
  convertToSource: (sync: any, dtdReq: IInterfaceDTDKey) => any;
  convertToSync: (source: any, dtdReq: IInterfaceDTDKey, dtdQueue?: IInterfaceDTDKey[]) => any;
}

export interface IInterfacePostprocessor {
  convertToSource: (sync: any, req: IInterfaceDTDKey) => any;
  convertToSync: (sync: any, req: IInterfaceDTDKey, dtdQueue?: IInterfaceDTDKey[]) => any;
}

export interface IInterface {
  fork(): IInterface;
  configuration(configuration: IInterfaceConfiguation): IInterfaceConfiguation;
  configure(configuration: IInterfaceConfiguation): IInterfaceConfiguation;
  configurePush(configuration: IInterfaceConfiguation): IInterfaceConfiguation;
  configurePop(): IInterfaceConfiguation;
  discoverType(type: any): string;
  type(name: string, typeConfiguration: IInterfaceType): IInterface;
  postprocessorsSupported(): string[];
  preprocessorsSupported(): string[];
  postprocessor(name: string, postprocessorDefinition: IInterfacePostprocessor): IInterface;
  preprocessor(name: string, preprocessorDefinition: IInterfacePreprocessor): IInterface;
  serialize(dtd: IInterfaceDTD, sync: any): void;
  implementObject(dtd: IInterfaceDTD, object: Object): Object;
  implementArray(dtd: IInterfaceDTD, list: any[]): any[];
  implement(dtd: IInterfaceDTD, source: any, sync: any): void;
  gateway(dtd: IInterfaceDTD, source: any, sync: any): any;
  merge(dtd: IInterfaceDTD, syncSource: any): any;
  make(dtd: IInterfaceDTD, source: any): any;
  generate(dtd: IInterfaceDTD): any;
}

const Interface: IInterface = require('./core') as IInterface;

import 'core-js-error';

require('./types/collections');
require('./types/database');
require('./types/dates');
require('./types/numeric');
require('./types/patterns');
require('./types/simple');
require('./types/types');

require('./preprocessors/key_value_pair');
require('./preprocessors/reverse_side_load_lookup');
require('./postprocessors/side_load_lookup');

export default Interface;



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/main.ts